import { render, staticRenderFns } from "./bad_handle.vue?vue&type=template&id=c06406ee&scoped=true&"
import script from "./bad_handle.vue?vue&type=script&lang=js&"
export * from "./bad_handle.vue?vue&type=script&lang=js&"
import style0 from "./bad_handle.vue?vue&type=style&index=0&id=c06406ee&scoped=true&lang=less&"
import style1 from "./bad_handle.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06406ee",
  null
  
)

export default component.exports